module.exports = __webpack_public_path__ + "static/media/confirmed.3a1c991e.svg";